<template>
<div class="__boolean_group">
	<label class="label">{{item.caption}}</label>
	<p v-if="item.description" class="__desc">{{item.description}}</p>
	<div class="__btns">
		<select-button v-for="option in item.options" :label="option.caption" :subtitle="option.description"
		               :value="option.value" no-icon v-model="config[item.name]"/>
	</div>
</div>
</template>

<script>
import SelectButton from "@/components/base/select_button";
export default {
	name: "boolean_group", components: {SelectButton},
	props:{
		item:{},
		config:{},
	},
	created() {

		// Set a default value.
		if (this.item.default && !this.config[this.item.name]) {
			this.$set(this.config, this.item.name, this.item.default);
		}
	}
}
</script>

<style lang="scss" scoped>
.__boolean_group {
	display: flex;
	flex-direction: column;

	.__btns {
		display: flex;
		flex-direction: row;
		gap: 10px;
		margin: 10px 0;
	}
	.__desc {
		margin: 0;
		font-size: 1rem;
		font-weight: 400;
		color: $dark-grey;
	}
	.label {
		color: $darker-grey;
	}
}
</style>
